// extracted by mini-css-extract-plugin
export default {"row":"RestrictionByIpTable_row_nFyCO"};